export const vStagger = {
  mounted(el, binding) {
    const step = binding.value?.step || 45
    const maxDelay = binding.value?.max || 180
    const selector = binding.value?.selector || ':scope > *'

    const children = el.querySelectorAll(selector)
    children.forEach((child, index) => {
      const delay = Math.min(index * step, maxDelay)
      child.style.setProperty('--stagger-delay', `${delay}ms`)
      child.classList.add('v-stagger-item')
    })
  },
  updated(el, binding) {
    const step = binding.value?.step || 45
    const maxDelay = binding.value?.max || 180
    const selector = binding.value?.selector || ':scope > *'

    const children = el.querySelectorAll(selector)
    children.forEach((child, index) => {
      const delay = Math.min(index * step, maxDelay)
      child.style.setProperty('--stagger-delay', `${delay}ms`)
    })
  }
}
